import { FC } from 'react';
import cx from 'clsx';
import Lottie from 'lottie-react';

import mainStyles from '../../styles.module.css';
import styles from './styles.module.css';
import lookUpAnimation from 'src/assets/lottie/look-up-arrows.json';

import { useLookAtPlayWallStep } from './useLookAtPlayWallStep';

export const LookAtPlayWallStep: FC = () => {
  const { lottieRef } = useLookAtPlayWallStep();

  return (
    <section className={cx(mainStyles.stepSection, styles.container)}>
      <Lottie
        lottieRef={lottieRef}
        className={styles.animation}
        animationData={lookUpAnimation}
        loop={true}
        autoplay={false}
      />
      <span className={styles.text}>
        Look at <br /> PlayWall
      </span>
    </section>
  );
};
